import { useSettingsStore } from '../stores/settingsStore';
import { useT } from '../i18n';

export const ThemeToggle = () => {
  const t = useT();
  const toggleTheme = useSettingsStore((s) => s.toggleTheme);
  const isLight = useSettingsStore((s) => s.isLight);

  return (
    <button
      onClick={toggleTheme}
      title={isLight ? t('theme.toggleToDark') : t('theme.toggleToLight')}
      className="w-9 h-9 flex items-center justify-center rounded-[14px] border-2 transition-all hover:scale-105 active:scale-95"
      style={{
        background: isLight ? 'var(--ctp-surface0)' : 'var(--ctp-surface0)',
        borderColor: isLight ? 'var(--ctp-surface1)' : 'var(--ctp-surface1)',
        color: isLight ? 'var(--ctp-subtext0)' : 'var(--ctp-subtext0)',
      }}
    >
      <span style={{ fontSize: '15px', lineHeight: 1 }}>
        {isLight ? '☽' : '☀'}
      </span>
    </button>
  );
};
